/**
 * Asynchronously loads the component for DormantCampaignsLeadsDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DormantCampaignsLeadsDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.DormantCampaignsLeadsDetailsPage,
);
